import React from 'react';

export const FormAPIContext = React.createContext<{
    refetchModel?: () => Promise<void>,
    overlayRef?: React.RefObject<HTMLDivElement>,
    loaderContentContainerRef?: React.RefObject<HTMLDivElement>,
    overlayDisplayed?: boolean,
    displayOverlay?: (state?: boolean) => void,
} | null>(null);
